var WhooosReadingServices = require("lib/web/WhooosReadingServices");

require("org/roster_upload/add_students_method_select.scss");

class AddStudentsMethodSelect extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {};
	}

	methodDescription(methodKey) {
		if (methodKey == "manual") {
			return "Type names manually";
		} else if (methodKey == "upload") {
			return "Upload a roster file";
		} else if (methodKey == "class-code") {
			return "Hand out a class code";
		} else if (methodKey == "google-classroom") {
			return "Sync Google Classroom";
		} else if (methodKey == "clever") {
			return "Sync Clever account";
		}
	}

	changeTab(tabKey) {
		this.setState({ mode: tabKey }, () => {
			$(window).trigger("resize");
		});
	}

	renderMethodOption(methodKey) {
		var className = "largeObject clickableElement";
		if (this.props.selectedOption == methodKey) {
			className += " selectedOption";
		}

		return (
			<div className={ className } key={ methodKey }
				onClick={ this.props.onMethodSelect.bind(this, methodKey) }>
				<div className="methodObjectContent">
					{ this.methodDescription(methodKey) }
				</div>
			</div>
		);
	}

	render() {
		if (this.props.methodOptions.length == 0) {
			var methodQuestion = (
				<p className="text-center">
					Rostering was disabled by your administator
				</p>
			);
		} else {
			var methodQuestion = (
				<p className="text-center">
					Select a method for adding your students
				</p>
			);

			var methodObjects = _.map(this.props.methodOptions, (methodKey) => {
				return this.renderMethodOption(methodKey);
			});
			var methodOptions = (
				<div className="methodOptions">
					{ methodObjects }
				</div>
			);
		}
		

		return (
			<div className="addStudentsMethodSelect">
				{ methodQuestion }
				{ methodOptions }
			</div>
		);
	}
};

AddStudentsMethodSelect.propTypes = StrictPropTypes({
	// method options to be displayed
	methodOptions: PropTypes.array.isRequired,
	selectedOption: PropTypes.string,

	// function to call when a method is selected
	onMethodSelect: PropTypes.func.isRequired,
});

module.exports = AddStudentsMethodSelect;



// WEBPACK FOOTER //
// ./modules/components/org/roster_upload/AddStudentsMethodSelect.js